var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVsCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    viewBox: "0 0 375 375",
    height: 375,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7a1f4f",
    d: "M 281.21875 0 L 281.21875 322.074219 L 0 280.296875 L 281.21875 375 L 374.96875 335.992188 L 374.96875 44.808594 L 375 44.800781 L 374.96875 44.734375 L 374.96875 39 Z M 182.8125 54.871094 L 96.671875 140.015625 L 44.8125 100.957031 L 23.441406 108.097656 L 76.199219 160.253906 L 23.441406 212.402344 L 44.8125 219.550781 L 96.671875 180.484375 L 182.796875 265.621094 L 234.390625 243.707031 L 234.390625 76.785156 Z M 182.796875 115.621094 L 182.796875 204.871094 L 123.542969 160.238281 Z M 182.796875 115.621094"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsCode);
export default __webpack_public_path__ + "static/media/vsCode.875f5f8ff15a589d2fa368ab2c6df4e8.svg";
export { ForwardRef as ReactComponent };